import { getDeviceInfo, } from '@office-start/device-detection-utility';
import { now } from '@office-start/performance-utility';
/**
 * requestIdleCallback and cancelIdleCallback are not supported in Safari
 *
 * Ref: shim-idle-callback.service.ts in OfficeHome
 *      https://developers.google.com/web/updates/2015/08/using-requestidlecallback#checking_for_requestidlecallback
 */
var isSafari = getDeviceInfo().browser.browserType === "Safari" /* BrowserType.Safari */;
var requestIdleCallbackShim = function (callback, _options) {
    return window.setTimeout(function () {
        var start = now();
        callback({
            didTimeout: false,
            timeRemaining: function () { return Math.max(0, 50 - (now() - start)); },
        });
    });
};
var cancelIdleCallbackShim = function (handle) {
    clearTimeout(handle);
};
export var requestIdleCallbackPolyfill = isSafari
    ? requestIdleCallbackShim
    : requestIdleCallback;
export var cancelIdleCallbackPolyfill = isSafari
    ? cancelIdleCallbackShim
    : cancelIdleCallback;
//# sourceMappingURL=IdleCallbackPolyfills.js.map